// Shared Stage C presentation. Never interpret a failed refresh as a failed write.
export function stockPostingErrorMessage(error, t) {
  const body = error?.response?.data || error?.data || error || {};
  const code = body.code || error?.code;
  const key = `stock:integration.codes.${code}`;
  const fallbackKey = `stock:postingSafety.codes.${code}`;
  const message = code ? t(key, { defaultValue: t(fallbackKey, { defaultValue: body.message || error?.message || t("stock:integration.requestFailed") }) }) : error?.message || t("stock:integration.requestFailed");
  const source = body.source_context;
  const detail = source ? ` · ${source.business_date || ""} · #${source.document_id || "—"}${source.line_id ? ` / #${source.line_id}` : ""}` : "";
  return `${message}${detail}${body.diagnostic_id ? ` · ${t("stock:integration.diagnosticId")}: ${body.diagnostic_id}` : ""}`;
}
export function parseStockSnapshot(value) { if (!value) return null; if (typeof value === "object") return value; try { return JSON.parse(value); } catch (_) { return null; } }
